import {CadenceStepProps} from './types';
import {Container} from './cadence-step.styles';
import {CadenceScheduleCard} from './cadence-schedule-card';
import {CadenceStartEndCard} from './cadence-start-end-card';

export const CadenceStep = ({
  compact = false,
  value,
  onChange,
}: CadenceStepProps) => {
  return (
    <Container $compact={compact}>
      <CadenceScheduleCard
        compact={compact}
        value={value}
        onChange={onChange}
      />
      <CadenceStartEndCard
        compact={compact}
        value={value}
        onChange={onChange}
      />
    </Container>
  );
};
